import { Stack, Divider, Text, Inline, Box } from 'braid-design-system';

import ThreadContent from 'src/components/atoms/ThreadContent/ThreadContent';
import ThreadPersonalDetails from 'src/components/atoms/ThreadPersonalDetails/ThreadPersonalDetails';
import type { ThreadCard } from 'src/mapper/threadMapper';

interface ThreadCardProps {
  thread: ThreadCard;
  isFeatured?: boolean;
  isCategoryThread?: boolean;
}

export default ({ thread }: ThreadCardProps) => {
  const {
    id,
    author,
    creationDate,
    description,
    category,
    exactSocialData,
    attachments,
    url,
    poll,
  } = thread;
  const postingDate = creationDate;
  const likeLabel = exactSocialData.likeCountLabel;
  const commentLabel = exactSocialData.commentAndReplyCountLabel;
  const images = attachments ?? [];

  // Poll state
  const voted = poll?.options.some((option) => option?.voted || false) || false;

  return (
    <Stack space="small">
      <ThreadPersonalDetails
        author={author}
        postingDate={postingDate}
        category={category}
        showJobTitle={false}
      />
      <a key={id} href={url} style={{ textDecoration: 'none' }}>
        <Stack space="gutter">
          <ThreadContent
            text={description}
            images={images}
            poll={poll}
            maxLines={2}
            voted={voted}
          />
          <Inline space="medium">
            <Text size="small" weight="regular" tone="secondary">
              {likeLabel} likes
            </Text>
            <Text size="small" weight="regular" tone="secondary">
              {commentLabel} comments
            </Text>
          </Inline>
        </Stack>
        <Box paddingTop="medium">
          <Divider weight="regular" />
        </Box>
      </a>
    </Stack>
  );
};
